import { Badge, Icon, NavItem, NavItemAccessor, Theme } from '@billy/design-system'
import { TFunction } from 'i18next'

import { Company } from '@modules-deprecated/app/companies/types'
import { getCompanyName } from '@modules-deprecated/app/companies/utils/getCompanyName'

import { NAV_ITEM_ID_CREATE_COMPANY } from '../constants/navItemIdCreateCompany'
import { CompanyValue } from '../types/companyValue'
import { getCompanyAddress } from './getCompanyAddress'

export interface GetItemsProps {
  companies: Company[]
  getCompanyDisplayTitle?: null | ((company: Company) => string)
  t: TFunction
  showAddress?: boolean
  isContactLookupAuthorized?: boolean
  allowCreate?: boolean
  theme: Theme
}

export const getItems = ({
  companies,
  t,
  allowCreate,
  isContactLookupAuthorized = false,
  showAddress = true,
  theme,
  getCompanyDisplayTitle = null,
}: GetItemsProps): NavItem<CompanyValue>[] => {
  const defaultItems = allowCreate
    ? [
        {
          accessor: NavItemAccessor.WithoutActiveState,
          children: t('company_select.dropdown.create_item.text'),
          leftDecoration: <Icon icon="circlePlus" color={theme.ds.colors.base.textPrimary} />,
          id: NAV_ITEM_ID_CREATE_COMPANY,
          value: {
            displayData: {
              title: t('company_select.dropdown.create_item.text'),
            },
          } as CompanyValue,
        },
        ...(companies.length
          ? [
              {
                accessor: NavItemAccessor.Separator,
                children: '',
                id: 'separator',
                value: {} as CompanyValue,
              },
            ]
          : []),
      ]
    : []

  const companiesOther: NavItem<CompanyValue>[] = []

  for (const company of companies) {
    const displayTitle = getCompanyDisplayTitle ? getCompanyDisplayTitle(company) : (getCompanyName(company) ?? '')
    const searchKeywords = [company.id, displayTitle]
    const address = getCompanyAddress(company)
    const description = showAddress ? [company.id, address] : [company.id]

    companiesOther.push({
      id: company.id,
      children: displayTitle,
      searchKeywords,
      value: {
        ...company,
        displayData: {
          title: displayTitle,
          description,
          suffix: !isContactLookupAuthorized ? <Badge>{t('company_select.dropdown.upgrade')}</Badge> : null,
        },
        isProtected: !isContactLookupAuthorized,
      },
    })
  }

  return [...defaultItems, ...companiesOther]
}
